import { Maths } from 'helpers/maths';
import { PlanProductLineItem } from '../../../types';

/**
 * yieldTotal is dollar revenue (yieldPerArea × pricePerUnit × area), not a
 * quantity — field paths keep the name for compatibility. Rounded the same
 * way as the `onControlledChange`/`onControlledBlur` handlers that persist
 * `projectedRevenue.yieldTotal`, so this live readout can't drift from that
 * field by a fraction of a cent.
 */
export const calculateYieldTotal = (
  yieldPerArea: number | null,
  pricePerUnit: number | null,
  area: number
): number =>
  Maths.multiplyRound(
    Maths.multiply(yieldPerArea ?? 0, pricePerUnit ?? 0),
    area,
    2
  );

// A blank field (mid-edit, before blur restores 100) counts as 100%, matching
// legacy Plans, so Projected Net Revenue doesn't flash to 0% while typing.
export const calculateCropSharePercentDecimal = (
  cropSharePercent: number | '' | null
): number =>
  cropSharePercent === '' || cropSharePercent == null
    ? 1
    : Maths.divideSafeRound(Number(cropSharePercent) || 0, 100, 4);

export const calculateVariableCostLive = (
  planProductEntries: PlanProductLineItem[] | undefined
): number =>
  (planProductEntries ?? []).reduce(
    (sum, product) => sum + (Number(product.totalProductCost) || 0),
    0
  );

export const calculateProjectedNetRevenue = (
  yieldTotal: number,
  fsaPayment: number | null,
  cropSharePercentDecimal: number,
  totalFixedCost: number,
  variableCostLive: number
): number =>
  Maths.minusRound(
    Maths.minusRound(
      Maths.multiplyRound(
        Maths.plus(yieldTotal, fsaPayment ?? 0),
        cropSharePercentDecimal,
        2
      ),
      totalFixedCost,
      2
    ),
    variableCostLive,
    2
  );
